import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../constants/queryKeys';
import { callPublicAPI } from '../utils/api';
import { Offer } from '../types/types';

export const useSimilarOffers = (offerId: string) => {
  return useQuery<Offer[]>({
    queryKey: [QUERY_KEYS.GET_SIMILAR_OFFERS, offerId],
    queryFn: async () => {
      const response = await callPublicAPI<Offer[]>('GET', `/offers/${offerId}/related`);
      return response.data;
    },
    enabled: Boolean(offerId)
  });
};
